export default __webpack_public_path__ + "static/media/comicz.39357511.ttf";